/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Shift_Event_BackwardInputs */

const en_shortcut_keys_name_shift_event_backward = /** @type {(inputs: Shortcut_Keys_Name_Shift_Event_BackwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shift Event Backward`)
};

const fr_shortcut_keys_name_shift_event_backward = /** @type {(inputs: Shortcut_Keys_Name_Shift_Event_BackwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decaler l'evenement vers l'arriere`)
};

const de_shortcut_keys_name_shift_event_backward = /** @type {(inputs: Shortcut_Keys_Name_Shift_Event_BackwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis rückwärts verschieben`)
};

const it_shortcut_keys_name_shift_event_backward = /** @type {(inputs: Shortcut_Keys_Name_Shift_Event_BackwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta evento indietro`)
};

const ru_shortcut_keys_name_shift_event_backward = /** @type {(inputs: Shortcut_Keys_Name_Shift_Event_BackwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обратный сдвиг события`)
};

const es_shortcut_keys_name_shift_event_backward = /** @type {(inputs: Shortcut_Keys_Name_Shift_Event_BackwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazar evento hacia atrás`)
};

const zh_cn2_shortcut_keys_name_shift_event_backward = /** @type {(inputs: Shortcut_Keys_Name_Shift_Event_BackwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向后移动事件`)
};

const ja_shortcut_keys_name_shift_event_backward = /** @type {(inputs: Shortcut_Keys_Name_Shift_Event_BackwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを後ろにシフト`)
};

const hi_shortcut_keys_name_shift_event_backward = /** @type {(inputs: Shortcut_Keys_Name_Shift_Event_BackwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटना को पीछे की ओर स्थानांतरित करें`)
};

const pt_pt2_shortcut_keys_name_shift_event_backward = /** @type {(inputs: Shortcut_Keys_Name_Shift_Event_BackwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deslocar evento para trás`)
};

/**
* | output |
* | --- |
* | "Shift Event Backward" |
*
* @param {Shortcut_Keys_Name_Shift_Event_BackwardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_shift_event_backward = /** @type {((inputs?: Shortcut_Keys_Name_Shift_Event_BackwardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Shift_Event_BackwardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_shift_event_backward(inputs)
	if (locale === "de") return de_shortcut_keys_name_shift_event_backward(inputs)
	if (locale === "it") return it_shortcut_keys_name_shift_event_backward(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_shift_event_backward(inputs)
	if (locale === "es") return es_shortcut_keys_name_shift_event_backward(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_shift_event_backward(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_shift_event_backward(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_shift_event_backward(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_shift_event_backward(inputs)
	return en_shortcut_keys_name_shift_event_backward(inputs)
});